var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scout-form",
    {
      attrs: {
        "is-modified": !!_vm.from || !!_vm.to,
        label: "最終ログイン時期の指定",
      },
    },
    [
      _c("term-select", {
        attrs: { from: _vm.from, to: _vm.to, "no-option": "" },
        on: {
          "update:from": function ($event) {
            return _vm.$emit("update:from", $event)
          },
          "update:to": function ($event) {
            return _vm.$emit("update:to", $event)
          },
        },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "boss-annotation-text" }, [
        _vm._v(
          "\n    ※アクティブ会員を検索するための項目です（会員登録、ログイン、応募など）\n  "
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }